import React from "react";
import { storyblokEditable } from "@storyblok/react";
import { InfoTextBannerModel } from "./InfoTextBannerModel";
import { useNavigate } from "react-router-dom";

import "./InfoTextBanner.css";

const InfoTextBanner: React.FC<{ blok: InfoTextBannerModel }> = ({ blok }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (blok.link?.cached_url) {
      if (blok.link?.linktype === "story") {
        navigate(`/${blok.link.cached_url}`);
      } else {
        const url = new URL(blok.link.cached_url, window.location.origin);
        window.location.href = url.href;
      }
    }
  };

  return (
    <div
      onClick={handleClick}
      {...storyblokEditable(blok)}
      className="info-text-banner"
      style={{ backgroundColor: blok.backgroundColor?.color }}
    >
      <div className="container">
        <div className="Text">
          <span style={{ color: blok.textColor?.color }}>{blok.text}</span>
        </div>

        <div className="SubText">
          <span style={{ color: blok.textColor?.color }}>{blok.subText}</span>
        </div>
      </div>
    </div>
  );
};

export default InfoTextBanner;
